import React, { Component } from 'react';
import axios from 'axios';
import {connect} from 'react-redux'
import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Components
// Styling

const getState = (state) =>{
    return {
        url: state.url
    }
} 

const Dispatch = (dispatch) =>{
    return {
        updateProfileFields: (data) =>{
            let action = {
                type:"updateProfileFields",
                data:data
            }
            dispatch(action)
        }
    }
}

class Profile extends Component {
    constructor(){
        super()
        this.state = {
            profile:{
                email:'',
                first_name:'',
                last_name:'',
                tel:'',
                password:'',
            }
        }
    }

    handleChange = (e) =>{
        let id = e.target.getAttribute("id")
        let profile = this.state.profile
        profile[id] = e.target.value
        this.setState({profile})
    }

    updateProfile = (e) =>{
        let key = cookies.get('key')
        e.preventDefault()
        let funcion = this.props.updateProfileFields
        let url = this.props.url
        axios.put(url + '/api/v1/core/user/update/' + key + '/',this.state.profile)
        .then(response =>{
            console.log(response)
            funcion(JSON.stringify(response.data))
        })
        .catch(err => {
            console.log(err)
        })
    }

    render() {
        return (
            <div className="col-lg-9">
                <div className="edit-profile pt-6">
                    <h5 className="text-center">Edita tu Perfil</h5>
                    <hr/>
                    <div className="col-8 offset-2">
                        <form id="editProfile" >
                            <div className="form-group pt-4">
                                <label htmlFor="names">Nombre/s</label>
                                <input type="text" className="form-control" onChange = {this.handleChange} value={this.state.profile.first_name} id="first_name" placeholder="Joe" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="last_name">Apellidos</label>
                                <input type="text" className="form-control" onChange = {this.handleChange} value={this.state.profile.last_name}  id="last_name" placeholder="Doe" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="correo">Correo Electrónico</label>
                                <input type="email" className="form-control" onChange = {this.handleChange} value={this.state.profile.email}  id="email"  placeholder="joe@countryclub.do"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="password">Contraseña</label>
                                <input type="password" className="form-control" onChange = {this.handleChange} value={this.state.profile.password}  id="password" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Teléfono / Celular</label>
                                <input type="phone" className="form-control" onChange = {this.handleChange} value={this.state.profile.tel}  id="tel" placeholder="(809) 000-0000"/>
                            </div>
                            <div className="text-center">
                                <button  onClick ={this.updateProfile} className="btn btn-success">Guardar Perfil</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(getState,Dispatch)(Profile);



// WEBPACK FOOTER //
// ./src/Pages/Profile/index.js